import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AuthGuardService } from './guards/auth.guard.service';

import { environment } from '../environments/environment.prod';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';



import { CustomerDataService } from "./services/customer-data.service";
import { AppComponent } from './app.component';
// import { LogoutComponent } from './logout/logout.component';
import { LoginComponent } from './login/login.component';
import { SignUpComponent } from './sign-up/sign-up.component'
import { CustomerModule } from './customer/customer.module';
import { AppRoutingModule } from './app-routing.module';
import { SettingComponent } from './setting/setting.component';
import { SitelistModule } from './customer/components/siteslist/sitelist.module';
import { SharedModule } from './shared.module';
import { MyHttpInterceptor } from './services/http.interceptor';
import { LogsComponent } from './logs/logs.component';
import { StatusComponent } from './status/status/status.component';
//import { ResetPasswordComponent } from './reset-password/reset-password.component';
// import { IconsProviderModule } from './icons-provider.module';


registerLocaleData(en);
@NgModule({
  declarations: [
    AppComponent, LoginComponent, SignUpComponent,
    SettingComponent,
    LogsComponent,
    StatusComponent
    // ResetPasswordComponent
  ],
  imports: [
    BrowserModule, CustomerModule, SitelistModule, AppRoutingModule,
    BrowserAnimationsModule, HttpClientModule, SharedModule,
    AngularFireDatabaseModule, AngularFirestoreModule,

  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: MyHttpInterceptor, multi: true },
    { provide: NZ_I18N, useValue: en_US }, CustomerDataService, AuthGuardService],
  bootstrap: [AppComponent]
})
export class AppModule { }
